import { Button, H3, PortableText, Section, SpacerWrapper } from '@ahmdigital/ui';

import { FootnoteType } from '../../../../../types/footnote';
import { Item } from '../../../types';
import { PortableTextType } from '../../../../../types/sanityInternal';
import { SellingPoint } from '../../../../../types/explained';
import getFootnoteSerializer from '../../../../../utils/get-footnote-serializer';
import insertFootnoteReference from '../../../../../utils/insert-footnote-reference';
import ItemsSection from '../section';
import styles from './styles.module.sass';

export type InclusionsPanelProps = {
  addons?: Item[];
  benefits?: Item[];
  contentTitle?: string;
  cta?: {
    name: string;
    url: string;
  };
  description?: string | PortableTextType[];
  descriptionFootnote?: FootnoteType;
  footnote?: FootnoteType;
  inclusions?: Item[];
  isPortableTextDescription?: boolean;
  sellingPoints?: SellingPoint[];
};

const InclusionsPanel = ({
  addons,
  benefits,
  contentTitle,
  cta,
  description,
  descriptionFootnote,
  footnote,
  inclusions,
  isPortableTextDescription,
  sellingPoints,
}: InclusionsPanelProps) => {
  const hasCta = cta?.name && cta?.url;
  return (
    <Section>
      <H3>
        <PortableText
          source={insertFootnoteReference({ footnote, text: contentTitle })}
          typeSerializers={getFootnoteSerializer({ footnote, variant: styles.footnote })}
        />
      </H3>
      {description && (
        <PortableText
          source={insertFootnoteReference({
            footnote: descriptionFootnote,
            text: description,
          })}
          typeSerializers={getFootnoteSerializer({
            footnote: descriptionFootnote,
            variant: [styles.footnote, styles.smallFootnote],
          })}
        />
      )}
      {/* @ts-expect-error - Automatic, Please fix when editing this file */}
      <ItemsSection items={inclusions} type="inclusions" />
      {/* @ts-expect-error - Automatic, Please fix when editing this file */}
      <ItemsSection items={benefits} type="benefits" />
      {/* @ts-expect-error - Automatic, Please fix when editing this file */}
      <ItemsSection items={addons} type="addons" />
      {/* @ts-expect-error - Automatic, Please fix when editing this file */}
      <ItemsSection items={sellingPoints} isPortableTextDescription={isPortableTextDescription} type="sellingPoints" />
      {hasCta && (
        <SpacerWrapper variant={[styles.cta, 'paddingTopSpacer6']}>
          <Button to={cta.url}>{cta.name}</Button>
        </SpacerWrapper>
      )}
    </Section>
  );
};

export default InclusionsPanel;
